import React from 'react';
import { Text } from 'quanta-ui';
import { useQuery } from '@apollo/client';

import { LOOKUP_FIELDUSER } from '../queries';

//import Loading from '../../../../../lib/layout/loading';
//import Error from '../../../../../lib/layout/error';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';

export default function GetFieldUserName({ code }) {
  const { loading, error, data } = useQuery(LOOKUP_FIELDUSER, {
    variables: {
      filter: {
      fieldUserID: code,
      },
    },
  });

  if (loading)
    return (
      <Loading
        textSize="normal"
        className="flex flex-row justify-start space-x-2 text-opacity-50 text-primary w-full"
      />
    );
  if (error)
    return (
      <Error className="flex flex-row justify-start space-x-2 text-base text-opacity-50 text-red-600 w-full" />
    );

  const { associatedEntityLookup } = data;

  return <Text>{associatedEntityLookup.fieldUserName}</Text>;
}
